var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadSideAssistanceAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / road_side_assistance_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "-3.38122072%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0",
    stopOpacity: 0.867132867,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "8.11168769%",
    x2: "92.9665065%",
    y2: "132.035683%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDAE35",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7606",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-road_side_assistance_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BreakDown",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8276626,74.6837979 C56.6187034,77.1525171 53.007685,79.1196015 49.1073342,80.4742031 C46.7381904,81.2971095 44.1323202,81.1261404 41.8176612,80.156689 C23.3529946,72.4255023 8.57449769,57.6470054 0.843310985,39.1823388 C-0.126140374,36.8676798 -0.297109509,34.2636883 0.525796877,31.8926658 C1.88039849,27.992315 3.84748293,24.3812966 6.31620209,21.1723374 C6.73517041,20.6293695 7.1672902,20.0976743 7.61444024,19.5772518 C8.30771069,18.7693756 9.57964591,18.8238603 10.2484922,19.6505243 L19.7081581,31.3346677 C20.2661562,32.0241806 20.2135503,33.0255712 19.5860373,33.6530843 L15.8397465,37.399375 C14.7105987,38.5285228 14.4719935,40.300214 15.3249604,41.6529368 C21.4291221,51.3474504 29.6506708,59.5689991 39.3470632,65.6750396 C40.699786,66.5261278 42.4695984,66.2894013 43.600625,65.1602535 L47.3469157,61.4139627 C47.9744288,60.7864497 48.9758194,60.7338438 49.6653323,61.2918419 L61.3494757,70.7515078 C62.1761397,71.4222329 62.2306244,72.6922893 61.4227482,73.3855598 C60.9023257,73.8327098 60.3706305,74.2648296 59.8276626,74.6837979 Z",
    id: "Phone---Fill",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.25,2 C46.8052719,-0.527388535 43.1947281,-0.527388535 41.75,2 L19.5,40.9534729 C25.0813909,49.3292084 32.4329499,56.5785259 40.9113216,62 L41.2311182,62 L44.6905647,58.5417652 C45.7252007,57.5037307 47.1078506,56.9320594 48.5789149,56.9320594 C49.8336462,56.9320594 51.0620413,57.3645739 52.0383614,58.1525023 L56.7901624,61.9981195 L76.25,61.9981195 C79.1394562,61.9981195 80.9310419,59.0067031 79.4994819,56.5 L48.25,2 Z",
    id: "Alert---Fill",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,53 L41.5,53 L41.5,45.75 L48.5,45.75 L48.5,53 Z M47,42 L43,42 L41,20 L49,20 L47,42 Z",
    id: "ExMark---Fill",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSideAssistanceAppTile);
export default __webpack_public_path__ + "static/media/road_side_assistance_app_tile.a69469ef0d1a9406a01c1e8f43e0ae89.svg";
export { ForwardRef as ReactComponent };